import React, {Component, useState, useEffect, Fragment } from 'react';
import { Message } from "element-react";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
// import './detail.scss';
import $ from 'jquery';
import classNames from 'classnames';
import API from '../../../config/api';
import {Toast} from 'antd-mobile';
import tools from '@/utils/tool';
import audioPlayIcon from '@/assets/audio_play_icon.png'
import audioPauseIcon from '@/assets/audio_pause_icon.png'
import audioSliderCircleIcon from '@/assets/slider_circle_icon.png'
import { Slider, WingBlank, WhiteSpace } from 'antd-mobile';
const DETAIL_TYPE = {
  PICTEXT: 'PICTEXT', // 图文
  VIDEO: 'VIDEO', // 视频
  SWIPER: 'SWIPER' // 图说
}
class Imagesay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uuid: '',
      data: {}, // 稿件数据，初始化为空对象防止首次渲染报错
      curSwiperText: '',
      curSwiperIndex: 1,
    }
  }
  componentWillMount() {
    const {data} = this.props
    this.setState({
      data,
    }, () => {
      this.replaceHref()
      // 数据加载完成后初始化 Swiper
      this.initSwiper();
      var cur = data.content[0];
        var cur_w = parseFloat(cur.width);
        var cur_h = parseFloat(cur.height);
        var h = cur_h / cur_w * 7.5
        $('#subject_swiper').css({
          height: h + 'rem'
        })
        document.title = data.title;
        this.setState({
          title: data.title,
          desc: data.desc,
        })
    })
  }
  
  componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    console.log(nextProps)
  }
  componentWillUnmount() {}
  // 获取图说稿件内容
  getSwiperContent() {
    let url = API.graph_article_detail
    // 稿件来源是文明实践时
    if(this.state.from === 'civilization'){
      url = API.civ_graph_article_detail
    }
    $.ajax({
      type: 'get',
      url: url,
      async: false,
      data: {
        uuid: this.state.uuid,
      },
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0 || res.errorCode == 0) {
        this.setState({
          data: res.data
        }, () => {
          this.replaceHref()
          // 数据加载完成后初始化 Swiper
          this.initSwiper(); 
        })
        var cur = res.data.content[0];
        var cur_w = parseFloat(cur.width);
        var cur_h = parseFloat(cur.height);
        var h = cur_h / cur_w * 7.5
        $('#subject_swiper').css({
          height: h + 'rem'
        })
        document.title = res.data.title;

        // this.initWx({
        //   title: res.data.title,
        //   desc: res.data.desc,
        // })
        this.setState({
          title: res.data.title,
          desc: res.data.desc,
        })
      } else {
        Toast.fail(res.msg || res.error);
        // this.props.history.push('/');
        return
      }
    });
  }
  // 初始化图说稿件的组件
  initSwiper() {
    var _this = this;
    this.subject_swiper = new window.Swiper('#subject_swiper', {
      direction: 'horizontal',
      loop: true,
      // spaceBetween: '.15rem',//只识别px
      // slidesOffsetAfter: '.3rem',
      // slidesOffsetBefore: '.3rem',
      // observer: true,
      // observeParents: true,
      initialSlide: 0,
      touchMoveStopPropagation: true,
      preventClicksPropagation: true,
      slidesPerView: 'auto',
      freeMode: false,
      autoplay: {
        delay: 2000, 
      },

      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
        // type: 'custom',
        // bulletClass:'my-bullet',
        // bulletActiveClass:'my-activeBullet',
      },

      // 如果需要前进后退按钮
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // 如果需要滚动条
      scrollbar: {
        el: '.swiper-scrollbar',
      },

      on: {
        slideChangeTransitionEnd: function () {
          _this.setState({
            curSwiperIndex: this.realIndex//切换结束时，告诉我现在是第几个slide
          })
          var cur = _this.state.data.content[this.realIndex];
          var cur_w = parseFloat(cur.width);
          var cur_h = parseFloat(cur.height);
          var h = cur_h / cur_w * 7.5
          $('#subject_swiper').css({
            height: h + 'rem'
          })
        },
      },
    })
  }
    // 将富文本中的a标签链接替换为当前环境的链接
  replaceHref() {
    console.log("888888888")
    for (var i = 0; i < $('a').length; i++) {
      var href = $($('a')[i]).attr('href')
      if (href.indexOf('type=') > -1 && href.indexOf('uuid=') > -1) {
        //替换
        var array = href.split('&');
        var obj = {};
        for (var j = 0; j < array.length; j++) {
          var arr = array[j].split('=');
          obj[arr[0]] = arr[1]
        }
        var new_href = API.host + '/index.html#/';
        switch (obj.type) {
          case 'article': // 文章
            new_href += 'detail/1/' + obj.uuid;
            break;
          case 'video': // 视频
            new_href += 'detail/2/' + obj.uuid + '/2';
            break;
          case 'live': // 直播
            new_href += 'detail/2/' + obj.uuid + '/6';
            break;
          case 'imageSays': // 图说
            new_href += 'detail/3/' + obj.uuid;
            break;
          case 'normalSpecial': // 常规专题
            new_href += 'subject/1/' + obj.uuid;
            break;
          case 'timeLineSpecial': // 时间线专题
            new_href += 'subject/2/' + obj.uuid;
            break;
          case 'newSpecial': // 新型专题
            new_href += 'newSubject' + obj.uuid;
            break;
        }
        $($('a')[i]).attr('href', new_href)
      }
    }
  }
  render() {
    const {data, audioDuration, audioCurTime, audioPlayStatus, playSpeedAry, curSelectSpeed, curSwiperText, curSwiperIndex} = this.state;
    return (
      <Fragment>
        <div style={{color:'#hsl(16.34deg 88.89% 50.59%)',fontSize:'14px', backgroundColor:'hsl(60deg 100% 50.2%)', padding:'10px 0px', textAlign:'center'}}>内部使用，请勿外传</div>
        <div className="sicSwiper-box">
          {
            data.desc ? (
              <div className="sicSwiper-title" style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                'WebkitLineClamp': '2',
                'WebkitBoxOrient': 'vertical',
              }}>{data.desc}</div>
            ) : ('')
          }
          <div className="sicSwiper-container" id="subject_swiper">
            <div className="swiper-wrapper" id="subject_list">
              {
                data.content.map((item, index) => {
                  // var suffix = Tool.getSuffix(item.cover, 500)
                  return (
                    <div className="swiper-slide" style={{
                      backgroundImage: 'url(' + item.image_url + ')'
                    }} key={index}></div>
                  )
                })
              }
            </div>
            {/*前进后退*/}
            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
          </div>
          <div className="sicSwiper-info">
            <div className="sicSwiper-num">{curSwiperIndex + 1 + '/' + data.content.length}</div>
          </div>
          <div className="sicSwiper-content">{data.content[curSwiperIndex].desc}</div>
        </div>
      </Fragment>
    )
  }
}
export default Imagesay



// WEBPACK FOOTER //
// ./src/pages/Preview/Imagesay/imagesay.js